import React from 'react';

const PRIMARY = '#2563EB';

const TransportTab = ({ formData, masterData, onChange }) => {
    const transporters = masterData.transporters || [];
    const carriers     = masterData.carriers     || [];

    const inputCls    = `w-full px-3 py-2.5 border border-[#CBD5E1] rounded-md text-sm bg-white outline-none transition-all duration-150 focus:border-[#2563EB] focus:shadow-[0_0_0_3px_rgba(37,99,235,0.1)] font-[inherit]`;
    const selectCls   = inputCls + ' cursor-pointer';
    const textareaCls = inputCls + ' resize-y';
    const labelCls    = 'block mb-1.5 text-xs font-semibold text-gray-600';

    const SectionTitle = ({ title }) => (
        <div className="flex items-center gap-2 mb-4 pb-2 border-b-2 border-gray-200">
            <div className="w-1 h-5 rounded-full" style={{ background: PRIMARY }} />
            <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide m-0">{title}</h3>
        </div>
    );

    const renderSelect = (field, label, options) => (
        <div className="flex flex-col">
            <label className={labelCls}>{label}</label>
            <select value={formData[field] || ''}
                onChange={e => onChange(field, e.target.value ? parseInt(e.target.value) : null)}
                className={selectCls}>
                <option value="">Select {label}</option>
                {options.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
            </select>
        </div>
    );

    const renderInput = (field, label, type = 'text') => (
        <div className="flex flex-col">
            <label className={labelCls}>{label}</label>
            <input type={type} value={formData[field] || ''}
                onChange={e => onChange(field, e.target.value)}
                className={inputCls} />
        </div>
    );

    const renderTextarea = (field, label, rows = 3) => (
        <div className="flex flex-col">
            <label className={labelCls}>{label}</label>
            <textarea value={formData[field] || ''} rows={rows}
                onChange={e => onChange(field, e.target.value)}
                className={textareaCls} />
        </div>
    );

    return (
        <div className="p-5 bg-white rounded-lg overflow-y-auto space-y-7">

            {/* ── Transport Information ── */}
            <section>
                <SectionTitle title="Transport Information" />
                <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4 mb-4">
                    {renderSelect('TransporterID', 'Transporter', transporters)}
                    {renderSelect('CarrierID', 'Carrier', carriers)}
                </div>
                <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4 mb-4">
                    {renderInput('TruckRegNo', 'Truck Registration No')}
                    {renderInput('DriverDetails', 'Driver Details')}
                </div>
                <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4">
                    {renderInput('CollectionDate', 'Collection Date', 'date')}
                    {renderInput('DeliveryDate', 'Delivery Date', 'date')}
                </div>
            </section>

            {/* ── Collection & Delivery ── */}
            <section>
                <SectionTitle title="Collection & Delivery" />
                <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4 mb-4">
                    {renderInput('CollectionPoint', 'Collection Point')}
                    {renderInput('DeliveryPoint', 'Delivery Point')}
                </div>
                <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4">
                    {renderInput('DeliveryNote', 'Delivery Note No')}
                </div>
            </section>

            {/* ── Instructions ── */}
            <section>
                <SectionTitle title="Instructions" />
                <div className="space-y-4">
                    {renderTextarea('CollectionInstructions', 'Collection Instructions', 3)}
                    {renderTextarea('DeliveryInstructions', 'Delivery Instructions', 3)}
                    {renderTextarea('ShippingInstruction', 'Shipping Instructions', 4)}
                </div>
            </section>

            {/* ── Remarks ── */}
            <section>
                <SectionTitle title="Remarks" />
                {renderTextarea('Remarks', 'General Remarks', 5)}
            </section>
        </div>
    );
};

export default TransportTab;